// Mixins
import AppPage from '../../mixins/app-page'

export default
{
    name: 'page-legal-notice',

    mixins:
    [
        AppPage
    ],

    components:
    {

    },

    data()
    {
        return {

        }
    },

    computed:
    {
        content()
        {
            return this.$root.contentPage.page.acf
        }
    },

    created()
    {
        console.log(this.content)
        // Events
        this.eventHub.$on('window:resize', this._onResize)
    },

    mounted()
    {
        this.eventHub.$emit('page:medias-loaded')
    },

    destroyed()
    {
        this.eventHub.$off('window:resize', this._onResize)
    },

    methods:
    {
        // Events
        _onResize()
        {
            //
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/page-legal-notice/script.js